import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import JobSummary, { JobSummaryAction } from '../../components/job-search/JobSummary';
import { useEffect, useReducer } from 'react';
import { JobPosting } from '../../services/job-search-service';
import { loadItem, LoadItemAction } from '../../services/live-search';
import JobPostingData from '../../components/structured-data/JobPostingData';
import Loading from '../../components/Loading';
import IndeedAttribution from '../../components/job-search/IndeedAttribution';
import { Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useTitle from '../../hooks/useTitle';
import { SearchItemAction } from '../../actions/SearchItemAction';
import Paper from '@material-ui/core/Paper';
// import SearchBreadcrumbList from '../../components/SearchBreadcrumbList';


interface JobPageState {
    loading: boolean;
    job?: JobPosting;
}
const initialState: JobPageState = {
    loading: true
};


function useJobReducer() {
    const setTitle = useTitle();

    function reducer(state: JobPageState, action: LoadItemAction<JobPosting> | JobSummaryAction | SearchItemAction) {
        console.info(action);
        switch (action.type) {
            case 'status':
                if (action.payload.submitted) {
                    return {...state, loading: true};
                }
                return state;
            case 'value':
                setTitle(action.payload.data ? action.payload.data.title : 'Job not found');
                return {...state, loading: false, job: action.payload.data};
            default:
                return state;
        }
    }

    return useReducer(reducer, initialState);
}


/** For now, the main purpose of this page is SEO */
export default function JobPage({match, history, location}: RouteComponentProps<{jobId?: string}>) {
    const [state, dispatch] = useJobReducer();

    useEffect(() => {
        const unsubscribe = loadItem('jobs', match.params.jobId!, dispatch);

        return () => {
            unsubscribe();
        };
    }, [match.params.jobId]);

    if (state.loading) {
        return <Loading/>;
    } else if (state.job) {
        // const crumbs = [{'Jobs': '/jobs'}, {state.job.title}]
        return (
            <Container maxWidth="sm" style={{paddingTop: 24}}>
                <JobPostingData job={state.job} />
                <Paper>
                    <JobSummary job={state.job!} dispatch={dispatch} />
                </Paper>
                {state.job.id.match(/^indeed-/) && <IndeedAttribution/>}
                <Link
                    to={{
                        pathname: '/jobs',
                        search: `?country=${state.job.address.country}&location=${state.job.address.city},${state.job.address.state}`
                    }}
                >
                    More jobs in {state.job.address.city}...
                </Link>
            </Container>
        );
    } else {
        return <div style={{textAlign: 'center', marginTop: 48}}>Sorry, the job could not be found</div>;
    }
}
